import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

// services
import { LoginService } from '../../../shared/services/login.service';
import { ErrorHandler } from '../../../shared/services/error-handler.service';
import { CopyService } from '../../../shared/services/app-copy.service';
// models
import { AppState } from '../../../booking/models/app-state.interface';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LanguageSelectorComponent } from '@shared/components/language-selector/language-selector.component';

@Component({
  selector: 'app-validate-email',
  standalone: true,
  imports: [CommonModule, FormsModule, LanguageSelectorComponent],
  templateUrl: './validate-email.component.html',
  styleUrls: ['./validate-email.component.scss'],
  providers: [LoginService]
})
export class ValidateEmailComponent implements OnInit, OnDestroy {

  private _subscription: Subscription;
  private _routeParamsSubscription: Subscription;
  private _userSubscription: Subscription;
  private _userLanguageSubscription: Subscription;
  private _bookingInitSubscription: Subscription;

  private _isRegister: Boolean = false;

  public showEmailSent: Boolean = false;
  public email: string;
  public linkExpired: Boolean = false;
  public showLoader: Boolean = false;
  public userEmail;
  public appCopy;
  public copyLoaded: Boolean = false;
  public selectedLanguage = '';

  constructor(
    private _appStore: Store<AppState>,
    private _loginService: LoginService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _errorHandler: ErrorHandler,
    private _copyService: CopyService,
  ) { }

  ngOnInit() {

    this._userLanguageSubscription = this._appStore.select('copyReducer')
    .subscribe((res: any) => {
    this.selectedLanguage = res.language
    })

    this._copyService.getStaticCopy()
      this._bookingInitSubscription = this._appStore.select('loadedStatusReducer')
        .subscribe((res: any) => {
          this.copyLoaded = res.copyLoaded;
            if (res.copyLoaded) {
              this.getCopy();
            }

        })

    this._userSubscription = this._appStore.select('userReducer')
      .subscribe((user: any) => {

        if (user.userDetails.userEmail === '') {
          this._router.navigate(['login']);
        }

        this.userEmail = user.userDetails.userEmail;

        this.linkExpired = user.userDetails.userEmailTokenValid;
      });

    this._subscription = this._loginService.forgotPasswordEmailSent$
      .subscribe(emailSent => {
        if (emailSent.error) {
          this.handleError();
          return;
        }

        if (this.showEmailSent) {
          this._errorHandler.handleCustomInfo({
            text: 'Email sent!',
            type: 'info'
          });
        }

        this.showEmailSent = emailSent;
      },
      err => console.log(err));

    // subscribe to router query string
    this._routeParamsSubscription = this._activatedRoute.queryParams
      .subscribe((params: any) => {
        if (params.step2 === 'true') {
          this.showEmailSent = true;
        }
        if (params.isRegister === 'true') {
          this._isRegister = true;
        }
      },
      err => console.log(err));
  }
  getCopy() {
    const panelHeaderCopy = this._copyService.getCopyBySection(
      'OTHER',
      'emailsent',
      ['showEmailSent']
    );
    console.log(panelHeaderCopy)
    this.appCopy = {
      panelHeader: panelHeaderCopy[0],
    };

  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
    .subscribe(s => state = s);
    return state;
  }

  handleError() {
    this.showLoader = false;
  }

  handleSubmitValidateEmail(value, event) {
    event.preventDefault();
    this.showLoader = true;
    this.email = value.email;
    this._loginService.sendResetPassword(this.email);
  }

  resendEmail() {

    const state = this.getState(this._appStore);
    if (typeof this.email === 'undefined') {
      this.email = state.userReducer.userDetails.userEmail;
    }
    this._loginService.sendResetPassword(this.email, this._isRegister);
  }

  goToLogin() {
    this._router.navigate(['access-account']);
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
    this._routeParamsSubscription.unsubscribe();
    this._userSubscription.unsubscribe();
    this._userLanguageSubscription.unsubscribe();
    this._bookingInitSubscription.unsubscribe();
  }

}
